import React, { useEffect } from 'react';
import { FinalCTA } from '../components/home/FinalCTA';
import { Button } from '../components/ui/Button';
import { useDrawers } from '../contexts/DrawerContext';
import { Phone, Star } from 'lucide-react';
// Confirm all qualification, admission and accreditation wording before production launch.
const CREDENTIALS = ['LL.B', 'B.A', 'LLM', 'Commercial Law Accredited Specialist'];
export function Team() {
  const {
    openQuote
  } = useDrawers();
  useEffect(() => {
    document.title = 'The Legal Team | L.A Property Law & Conveyancing';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-710">
      <section className="px-5 md:px-6 pt-12 md:pt-20 pb-16 md:pb-24 bg-background" data-id="element-711">
        <div className="max-w-7xl mx-auto" data-id="element-712">
          <div className="max-w-2xl mb-12" data-id="element-713">
            <p className="font-script text-2xl text-accent mb-1" data-id="element-714">
              the legal team
            </p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.08]" data-id="element-715">
              Legal advice from people you can identify.
            </h1>
            <p className="mt-5 text-lg text-muted-ink leading-relaxed" data-id="element-716">
              You will know who is handling your matter. That is the point of a
              boutique, lawyer-led practice.
            </p>
          </div>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start" data-id="element-717">
            <div className="lg:col-span-5" data-id="element-718">
              <div className="relative rounded-4xl overflow-hidden shadow-warm" data-id="element-719">
                <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=900&q=80" alt="Professional portrait of Linda Ashley, Principal Solicitor" className="w-full h-[380px] md:h-[460px] object-cover" data-id="element-720" />
                <div className="absolute bottom-4 left-4 right-4 rounded-2xl bg-surface/95 backdrop-blur px-4 py-3 flex items-center gap-2 shadow-card" data-id="element-721">
                  <Star className="w-4 h-4 text-accent fill-accent" data-id="element-722" />
                  <span className="text-sm font-semibold text-ink" data-id="element-723">
                    5.0 Google rating
                  </span>
                  <span className="text-sm text-muted-ink" data-id="element-724">· 10 reviews</span>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7" data-id="element-725">
              <h2 className="font-serif text-3xl text-ink" data-id="element-726">Linda Ashley</h2>
              <p className="text-accent font-semibold mt-1" data-id="element-727">
                Principal Solicitor
              </p>
              <p className="mt-5 text-lg text-muted-ink leading-relaxed" data-id="element-728">
                Linda's associated firm profile describes experience across
                property, commercial transactions, trusts, SMSFs, contracts and
                related disputes. That breadth means a property matter that
                turns into something more complex stays in capable hands.
              </p>

              <div className="mt-6 flex flex-wrap gap-2" data-id="element-729">
                {CREDENTIALS.map(c => <span key={c} className="inline-flex items-center rounded-full bg-soft-panel border border-border px-3 py-1.5 text-sm font-medium text-ink" data-id="element-730">
                    {c}
                  </span>)}
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-731">
                <Button onClick={openQuote} variant="accent" size="lg" data-id="element-732">
                  Get a free quote
                </Button>
                <a href="tel:+61386172600" data-id="element-733">
                  <Button variant="outline" size="lg" data-id="element-734">
                    <Phone className="w-4 h-4" data-id="element-735" />
                    Call (03) 8617 2600
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FinalCTA data-id="element-736" />
    </main>;
}